import React, { useState } from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './app/config/themaConfig';
import { Dashboard } from './dashboard';
import { useSelector } from 'react-redux';
import { selectUser } from './user/domain/userSlice';
import { SinginForm, UserAdmin } from './user';
import { CentralDeVida } from './centraldevida';
import { menus as menuBascula } from './centraldevida/menu/menuJson';
import withAuthentication from './user/componet/session/withAuthentication';
import { menuPoll } from './polls/domain/menuPoll';
import { Poll } from './polls';
import ForgotPass from './user/componet/Singin/ForgotPass';
import backgrounddev from '../src/img/Background_dev.png'
import backgroundqa from '../src/img/Background_qa.png'
import backgroundprod from '../src/user/componet/img/Background_log_08.png'

function App() {
  const user = useSelector(selectUser);
  const menu = menuBascula().concat(menuPoll());
  const [isforgot, setIsForgot] = useState(false);

  const handleForgotPassword = () => {
    setIsForgot(true);
  };

  const handleGoBackFromForgot = () => {
    setIsForgot(false);
  };


  //cambio de fondo dependiendo del entorno
  let backgroundImage;
  if (process.env.REACT_APP_BACKGROUND_IMAGE === 'background_dev') {
    backgroundImage = `url(${backgrounddev})`;
  } else if (process.env.REACT_APP_BACKGROUND_IMAGE === 'background_qa') {
    backgroundImage = `url(${backgroundqa})`;
  } else if (process.env.REACT_APP_BACKGROUND_IMAGE === 'background_prod') {
    backgroundImage = `url(${backgroundprod})`;
  } else {
    backgroundImage = 'var(--background-image)';
  }
  
  return (
    <div className={`container ${user ? 'logged-in' : 'not-logged-in'}`}  style={{ backgroundImage: user ? 'none' : backgroundImage }}>
      <ThemeProvider theme={theme}>
        {
          user ?
            <Dashboard menu={menu}>
              <UserAdmin />
              <CentralDeVida />
              <Poll />
            </Dashboard> :
            isforgot ? (
              <ForgotPass onBackToSignIn={handleGoBackFromForgot} />
            ) : (
              <div className="signin-container">
                <SinginForm onForgotPassword={handleForgotPassword} />
              </div>
            )
        }
      </ThemeProvider>
    </div>
  );
}

export default withAuthentication(App);
